import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n';
import { CheckboxModule } from '../../../../../shared';
import { UserDetailsShipToListItemGroupComponent } from './user-details-ship-to-list-item-group/user-details-ship-to-list-item-group.component';
import { UserDetailsShipToListRowGroupComponent } from './user-details-ship-to-list-row-group/user-details-ship-to-list-row-group.component';
import { UserDetailsShipToListRowComponent } from './user-details-ship-to-list-row/user-details-ship-to-list-row.component';

@NgModule({
  declarations: [
    UserDetailsShipToListItemGroupComponent,
    UserDetailsShipToListRowGroupComponent,
    UserDetailsShipToListRowComponent,
  ],
  imports: [CommonModule, CheckboxModule, I18nModule, NzIconModule, NgbTooltipModule],
  exports: [UserDetailsShipToListItemGroupComponent, UserDetailsShipToListRowGroupComponent, UserDetailsShipToListRowComponent],
})
export class UserDetailsShipToListElementModule {}
